'use client';
import React from 'react';
import Hooks from '@benzinga/hooks';
import { AuthenticationManager, AuthenticationManagerEvent } from '@benzinga/session';
import { SessionContext } from '@benzinga/session-context';

export const useHasSession = () => {
  const authenticationManager = React.useContext(SessionContext).getManager(AuthenticationManager);
  const hasToken = authenticationManager.getBenzingaToken() ? true : false;
  const update = Hooks.useForceUpdate();

  Hooks.useSubscriber(authenticationManager, (event: AuthenticationManagerEvent) => {
    switch (event.type) {
      case 'authentication:session_update':
        update();
        break;
    }
  });

  return hasToken;
};
